export const HistoryIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 10.6665V15.9998L19.3333 19.3332"
          stroke="#1C274C"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.47219 7.47219L6.76508 6.76508L7.47219 7.47219ZM5.78368 9.16069L4.78369 9.16572C4.78645 9.71408 5.2303 10.1579 5.77866 10.1607L5.78368 9.16069ZM9.17272 10.1777C9.725 10.1805 10.175 9.73505 10.1777 9.18278C10.1805 8.6305 9.73505 8.18054 9.18278 8.17776L9.17272 10.1777ZM6.76661 5.7616C6.76384 5.20932 6.31388 4.76386 5.7616 4.76664C5.20932 4.76941 4.76386 5.21937 4.76664 5.77165L6.76661 5.7616ZM5.10214 14.3799C5.17714 13.8327 4.79437 13.3284 4.24721 13.2534C3.70004 13.1784 3.19567 13.5611 3.12067 14.1083L5.10214 14.3799ZM25.1496 6.85036C20.0561 1.75677 11.825 1.70519 6.76508 6.76508L8.17929 8.17929C12.4448 3.91382 19.4095 3.9386 23.7354 8.26457L25.1496 6.85036ZM6.85036 25.1496C11.9439 30.2432 20.175 30.2948 25.2349 25.2349L23.8207 23.8207C19.5552 28.0862 12.5905 28.0614 8.26457 23.7354L6.85036 25.1496ZM25.2349 25.2349C30.2948 20.175 30.2432 11.9439 25.1496 6.85036L23.7354 8.26457C28.0614 12.5905 28.0862 19.5552 23.8207 23.8207L25.2349 25.2349ZM6.76508 6.76508L5.07657 8.45359L6.49079 9.8678L8.1793 8.17929L6.76508 6.76508ZM5.77866 10.1607L9.17272 10.1777L9.18278 8.17776L5.78871 8.16071L5.77866 10.1607ZM6.78367 9.15567L6.76661 5.7616L4.76664 5.77165L4.78369 9.16572L6.78367 9.15567ZM3.12067 14.1083C2.58543 18.0132 3.83189 22.1312 6.85036 25.1496L8.26457 23.7354C5.70381 21.1747 4.64884 17.687 5.10214 14.3799L3.12067 14.1083Z"
          fill="#1C274C"
        />
      </svg>
    </>
  );
};
